module.exports = __webpack_public_path__ + "static/media/swot-nav-icon.3e8563b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/swot-nav-icon.svg
// module id = 569
// module chunks = 0